import api from '@api/endpoints';
import { ALERT_STATUS_TYPE } from '@constants';
import { setAlert } from '@store/actions/alertActions';

export const getReferenceTypes =
  ({ onSuccess }) =>
  async (dispatch) => {
    try {
      const { data } = await api.vanceCashV2.getReferenceTypes();
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    }
  };
export const getAllRewardTxnsV2 =
  ({ userId, adjCnt, walletType = 'CASH', onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.vanceCashV2.getAllTransactionsV2({
        walletType,
        userId,
        adjCnt
      });
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
export const creditRewardV2 =
  ({ formData, walletType = 'CASH', onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.vanceCashV2.credit({
        walletType: walletType,
        requestBody: formData
      });
      dispatch(
        setAlert({
          title: 'Credit Successful',
          status: ALERT_STATUS_TYPE.SUCCESS
        })
      );
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const debitRewardV2 =
  ({ formData, walletType = 'CASH', onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.vanceCashV2.debit({
        walletType: walletType,
        requestBody: formData
      });
      dispatch(
        setAlert({
          title: 'Debit Successful',
          status: ALERT_STATUS_TYPE.SUCCESS
        })
      );
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
